import { render, staticRenderFns } from "./OrgstructTreeNode.vue?vue&type=template&id=c483693c"
import script from "./OrgstructTreeNode.vue?vue&type=script&lang=js"
export * from "./OrgstructTreeNode.vue?vue&type=script&lang=js"
import style0 from "./OrgstructTreeNode.vue?vue&type=style&index=0&id=c483693c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports